import { ReactNode } from 'react';
import { cn } from '@/lib/core';

export interface SheetHeaderProps {
  /** Optional left slot (e.g. back arrow button). */
  left?: ReactNode;
  /** Centred uppercase title. */
  title: string;
  /** Optional right slot (e.g. close button). */
  right?: ReactNode;
  className?: string;
}

/**
 * 3-slot sheet header shared by Filter / Wishlist / Manage-List sheets.
 * Reuses the handle pill from `Drawer showSwipeHandle`.
 */
export function SheetHeader({ left, title, right, className }: SheetHeaderProps) {
  return (
    <div className={cn('flex shrink-0 items-center justify-between px-2 py-3.75', className)}>
      <div className="flex size-11 items-center justify-center">{left}</div>
      <p className="font-pp-neue-montreal text-jncquoi-neutral-1000 text-[14px] leading-none font-normal tracking-[0.5px] uppercase">
        {title}
      </p>
      <div className="flex size-11 items-center justify-center">{right}</div>
    </div>
  );
}
